import Button from "@Components/Button";
import DotsAnimationLoader from "@Components/DotsTypingLoader";
import { AppState } from "@Store/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { HAPPY_FLOW_TENANCY_CTAS } from "constants/index";
import useIsHappyFlow from "hooks/useIsHappyFlow";
import { useSelector } from "react-redux";
import styles from "./contactUsSection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsDesktop from "hooks/useIsDesktop";
import useTranslationHook from "hooks/useTranslationHook";
//

type ContactUsSectionProps = {
  title: string;
  CTA: string;
  onClick: any;
  withButton?: boolean;
  id?: number;
  className?: string;
};

const ContactUsSection = ({
  title = "propertypage.roomtypesectiondynamic.roomtypecard.looking",
  CTA = "propertypage.roomtypesectiondynamic.roomtypecard.contactus",
  onClick,
  withButton = false,
  id,
  className,
}: ContactUsSectionProps) => {
  const isHappyFlow = useIsHappyFlow();
  const isDesktop = useIsDesktop();
  const { t } = useTranslationHook();
  const { activeTenancyId, inventoriesData } = useSelector(
    ({ leadFormModal, userHistory }: AppState) => ({
      activeTenancyId: leadFormModal.activeTenancyId,
      inventoriesData: userHistory.inventoriesData,
    }),
  );

  const { ctaText, shouldDisable } = (() => {
    if (Object.keys(inventoriesData.children).length > 0 && inventoriesData.children[String(id)]) {
      return {
        ctaText: inventoriesData.children[String(id)].label,
        shouldDisable:
          inventoriesData.children[String(id)].label === HAPPY_FLOW_TENANCY_CTAS.CONTACTED ||
          inventoriesData.children[String(id)].label === HAPPY_FLOW_TENANCY_CTAS.WAITLISTED,
      };
    }
    return {
      ctaText: CTA,
      shouldDisable: false,
    };
  })();

  const ContactUsText = () =>
    shouldDisable ? (
      <span className={formatClassNames(styles.contactUsSection_primary, styles.contacted)}>
        {t("propertypage.roomtypesectiondynamic.roomtypecard.youarecovered")}
      </span>
    ) : (
      <span
        role="none"
        data-testid="property-room-type-other-dates-contact us"
        className={styles.contactUsSection_secondary}
        onClick={onClick}
      >
        {isHappyFlow && id == activeTenancyId ? <DotsAnimationLoader /> : t(ctaText || CTA)}
      </span>
    );

  return (
    <div
      className={formatClassNames(styles.contactUsSection, isDesktop && styles.desktop, className)}
    >
      <span className={styles.contactUsSection_primary}>{title}</span>
      {withButton ? (
        <Button
          dataTestId="property-room-type-soldout-tenancy-Join-Waitlist"
          variant="outline"
          showLoader={isHappyFlow && id === activeTenancyId}
          className={styles.btn}
          onClick={onClick}
          disable={shouldDisable}
        >
          {t(ctaText || CTA)}
        </Button>
      ) : (
        <ContactUsText />
      )}
    </div>
  );
};

export default wrapperHOC(ContactUsSection, {
  componentName: "ContactUsSection-RoomTypeCard-RoomTypeSection-PropertyPage",
  showForChina: true,
});
